import BackTop from 'antd/es/back-top';
import { withConfigProvider } from '../config-provider';
export default withConfigProvider(BackTop);
